import { NavItem } from './navItem';
export const NAVIGATION_ITEMS: NavItem[] = [
  {
    id: 1,
    title: 'Ships',
    entitlement: 'MENU_SHIPS',
    icon: 'icon-NC_ship',
    route: '/shipProfiles',
    hasChildren: true
  },
  {
    id: 2,
    title: 'Cardholders',
    entitlement: 'MENU_CARDHOLDERS',
    icon: 'icon-NC_cardholders',
    route: '/cardholderProfiles',
    hasChildren: true
  },
  {
    id: 3,
    title: 'Visitor Cards',
    entitlement: 'MENU_VISITOR_CARDS',
    icon: 'icon-NC_Vistorcard',
    route: '/visitorCards'
  },
  {
    id: 4,
    title: 'Bulk Transfers',
    entitlement: 'MENU_BULK_TRANSFERS',
    icon: 'icon-NC_Bulktransfer',
    route: '/bulkTransfers'
  },
  {
    id: 5,
    title: 'Merchants',
    entitlement: 'MENU_MERCHANTS',
    icon: 'icon-NC_Merchant',
    route: '/merchantProfiles',
    hasChildren: true
  },
  {
    id: 6,
    title: 'Reports',
    entitlement: 'MENU_REPORTS',
    icon: 'icon-NC_Reports',
    route: '/reports/shipReports'
  },
  {
    id: 10,
    title: 'Cardholder Accounts',
    entitlement: 'MENU_CARDHOLDER_ACCOUNTS',
    icon: 'fa fa-credit-card',
    route: '/cardholder',
    hasChildren: true
  },
  {
    id: 11,
    title: 'Cardholders',
    entitlement: 'COAL_CH_VIEW',
    icon: 'fa fa-credit-card',
    route: '/cardholderProfiles'
  },
  { id: 13, title: 'My Account', route: null, hasChildren: true },
  { id: 14, parent: 13, title: 'Messages', route: '/users/messages' },
  {
    id: 16,
    parent: 5,
    title: 'Accounts',
    hasHeader: true,
    route: '/merchantProfiles/accounts',
    entitlement: 'TAB_MERCHANTS_ACCOUNTS'
  },
  {
    id: 17,
    parent: 5,
    title: 'History',
    hasHeader: true,
    route: '/merchantProfiles/history',
    entitlement: 'TAB_MERCHANTS_HISTORY'
  },
  {
    id: 18,
    parent: 5,
    title: 'ACH Funding',
    hasHeader: true,
    route: '/merchantProfiles/achFunding',
    entitlement: 'TAB_MERCHANTS_ACH_FUNDING',
    merchantTypes: 'PVT'
  },
  {
    id: 19,
    parent: 5,
    title: 'Settlement',
    hasHeader: true,
    route: '/merchantProfiles/settlement',
    entitlement: 'TAB_MERCHANTS_SETTLEMENT',
    merchantTypes: 'PVT,TRANS'
  },
  {
    id: 20,
    parent: 5,
    title: 'Adjustments',
    hasHeader: true,
    route: '/merchantProfiles/adjustments',
    entitlement: 'TAB_MERCHANTS_ADJUSTMENTS'
  },
  {
    id: 22,
    parent: 5,
    title: 'Notes',
    hasHeader: true,
    route: '/merchantProfiles/notes',
    entitlement: 'TAB_MERCHANTS_NOTES'
  },
  {
    id: 23,
    parent: 1,
    title: 'Round Trips',
    hasHeader: true,
    route: '/shipProfiles/roundtrips',
    entitlement: 'TAB_SHIPS_ROUNDTRIPS'
  },
  {
    parent: 1,
    id: 24,
    title: 'Merchants',
    hasHeader: true,
    route: '/shipProfiles/merchants',
    entitlement: 'TAB_SHIP_MERCHANTS'
  },
  {
    id: 25,
    parent: 1,
    title: 'Contacts',
    hasHeader: true,
    route: '/shipProfiles/contacts',
    entitlement: 'TAB_SHIP_CONTACTS'
  },
  {
    id: 26,
    parent: 1,
    title: 'Card Orders',
    hasHeader: true,
    route: '/shipProfiles/bulkcards',
    entitlement: 'TAB_SHIPS_BULK_CARDS'
  },
  {
    id: 27,
    parent: 1,
    title: 'Hull Swap',
    hasHeader: true,
    route: '/shipProfiles/hullswaps',
    entitlement: 'TAB_SHIPS_HULL_SWAP'
  },
  {
    id: 28,
    parent: 2,
    title: 'Accounts',
    hasHeader: true,
    route: '/cardholderProfiles/accounts',
    entitlement: 'TAB_CARDHOLDERS_ACCOUNTS'
  },
  {
    id: 29,
    parent: 2,
    title: 'History',
    hasHeader: true,
    route: '/cardholderProfiles/history',
    entitlement: 'TAB_CARDHOLDERS_HISTORY'
  },
  {
    id: 30,
    parent: 2,
    title: 'ACH Funding',
    hasHeader: true,
    route: '/cardholderProfiles/achFunding',
    entitlement: 'TAB_CARDHOLDERS_ACH_FUNDING'
  },
  {
    id: 31,
    parent: 2,
    title: 'Adjustments',
    hasHeader: true,
    route: '/cardholderProfiles/adjustments',
    entitlement: 'TAB_CARDHOLDERS_ADJUSTMENTS'
  },
  {
    id: 32,
    parent: 2,
    title: 'Personal',
    hasHeader: true,
    route: '/cardholderProfiles/personal',
    entitlement: 'TAB_CARDHOLDERS_PERSONAL'
  },
  {
    id: 37,
    parent: 2,
    title: 'Forms',
    hasHeader: true,
    route: '/cardholderProfiles/forms',
    entitlement: 'TAB_CARDHOLDERS_FORMS_HISTORY'
  },
  {
    id: 33,
    parent: 2,
    title: 'Notes',
    hasHeader: true,
    route: '/cardholderProfiles/notes',
    entitlement: 'TAB_CARDHOLDERS_NOTES'
  },
  { id: 34,
    parent: 2,
    title: 'Visa Forward',
    hasHeader: true,
    route: '/cardholderProfiles/visaForward',
    entitlement: 'TAB_CARDHOLDERS_VISA_FORWARD'
  },
  {
    id: 35,
    parent: 3,
    title: 'Accounts',
    hasHeader: true,
    route: '/visitorCards/accounts',
    entitlement: 'TAB_VISITORS_ACCOUNTS'
  },
  {
    id: 36,
    parent: 3,
    title: 'Adjustments',
    hasHeader: true,
    route: '/visitorCards/adjustments',
    entitlement: 'TAB_VISITORS_ADJUSTMENTS'
  },
  {
    id: 38,
    parent: 10,
    title: 'Account',
    entitlement: 'MENU_CARDHOLDER_ACCOUNTS',
    route: '/cardholder/accountDetails'
  },
  {
    id: 39,
    parent: 10,
    title: 'History',
    entitlement: 'MENU_CARDHOLDER_ACCOUNTS',
    route: '/cardholder/history'
  },
  {
    id: 41,
    parent: 1,
    hasHeader: true,
    title: 'Access Detail',
    entitlement: 'SHIPS_ACCESS_PASSWORDS',
    route: '/shipProfiles/accessDetails'
  },
  {
    id: 42,
    parent: 5,
    title: '2888 Forms',
    hasHeader: true,
    route: '/merchantProfiles/merchantForms',
    entitlement: 'TAB_MERCHANT_FORMS'
  },
  {
    id: 43,
    parent: 1,
    title: 'Roster',
    hasHeader: true,
    route: '/shipProfiles/ship-roster',
    entitlement: 'TAB_SHIP_ROSTER'
  },
  {
    id: 44,
    title: 'Ship User Maintenance',
    entitlement: 'MENU_MAINTAIN_USER',
    icon: 'icon-NC_Maintainuser',
    route: '/users/maintainShipUser'
  },
  {
    id: 45,
    parent: 1,
    title: 'Logs',
    hasHeader: true,
    route: '/shipProfiles/logs',
    entitlement: 'TAB_SHIP_LOGS'
  },
  { id: 46,
    parent: 5,
    title: 'Visa Forward',
    hasHeader: true,
    route: '/merchantProfiles/visaForward',
    entitlement: 'TAB_CARDHOLDERS_VISA_FORWARD'
  },
  { id: 7,  entitlement: 'MENU_SYSTEM', icon: 'fa fa-list-alt',  title: 'System', route: '/system', hasChildren: true },
  { id: 8, entitlement: 'TAB_CARDORDER_SYSTEM', parent: 7, title: 'Card Order', route: '/system/cardOrder' },
  {
    id: 47,
    parent: 1,
    title: 'Marines Bulk Enrollment',
    hasHeader: true,
    route: '/shipProfiles/marines-bulk-enrollment',
    entitlement: 'TAB_MARINES_BULK_ENROLLMENT'
  },
  {
    id: 48,
    title: 'VISA Reports',
    entitlement: 'MENU_VISA_REPORTS',
    icon: 'icon-NC_VISA_reports',
    route: '/reports/visaReports'
  }
];
